<template>
  <button :type="type" :disabled="isSubmitting" :class="`${defaultClasses} ${extraClasses}`" @click="$emit('click')">
    <template v-if="isSubmitting">
      <template v-if="useDNALoading">
        <div class="absolute left-0 flex items-center justify-center align-middle pl-3 text-center">
          <div class="loader">
            <div class="dot dot1">
              <i />
            </div>
            <div class="dot dot2">
              <i />
            </div>
            <div class="dot dot3">
              <i />
            </div>
            <div class="dot dot4">
              <i />
            </div>
            <div class="dot dot5">
              <i />
            </div>
            <div class="dot dot6">
              <i />
            </div>
            <div class="dot dot7">
              <i />
            </div>
            <div class="dot dot8">
              <i />
            </div>
            <div class="dot dot9">
              <i />
            </div>
          </div>
        </div>
      </template>
      <RotateCw v-else :class="[isSubmitting ? 'animate-spin' : '']" class="-ml-1 mr-3 h-5 w-5" aria-hidden="true" />
    </template>
    <span v-if="isSubmitting && submittingLabel" class="flex-1"> {{ submittingLabel }} </span>
    <span v-else class="flex-1"> {{ translatedLabel }} </span>
  </button>
</template>
<script>
import { RotateCw } from "lucide-vue-next"
export default {
  components: {
    RotateCw
  },
  props: {
    type: {
      type: String,
      default: "submit"
    },
    submittingLabel: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "Submit"
    },
    useDNALoading: {
      type: Boolean,
      default: true
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    defaultClasses: {
      type: String,
      default: "primary-btn w-full relative disabled:bg-opacity-50"
    },
    extraClasses: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  computed: {
    translatedLabel() {
      return this.$t(this.label)
    }
  }
}
</script>
<style scoped>
.loader {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 120px;
  height: 20px;
  zoom: 0.5;
}

.dot {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 0 5px;
  height: 20px;
  width: 2px;
}

.dot:first-of-type {
  margin-left: 0;
}

.dot:last-of-type {
  margin-right: 0;
}

.dot::before,
.dot::after {
  content: "";
  position: absolute;
  bottom: -5px;
  display: block;
  width: 4px;
  height: 4px;
  background: white;
  border-radius: 4px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.15);
  animation: helix 0.5s ease-in-out infinite;
}

.dot::after {
  bottom: 100%;
  animation: helix-reversed 0.5s ease-in-out infinite;
}

.dot i {
  position: absolute;
  z-index: 25;
  align-self: center;
  width: 2px;
  height: 10px;
  background: white;
  animation: helix-bar 1.25s ease-in-out infinite;
}

.dot2::before,
.dot2::after,
.dot2 i {
  animation-delay: 0.05s;
}

.dot3::before,
.dot3::after,
.dot3 i {
  animation-delay: 0.1s;
}

.dot4::before,
.dot4::after,
.dot4 i {
  animation-delay: 0.15s;
}

.dot5::before,
.dot5::after,
.dot5 i {
  animation-delay: 0.2s;
}

.dot6::before,
.dot6::after,
.dot6 i {
  animation-delay: 0.25s;
}

.dot7::before,
.dot7::after,
.dot7 i {
  animation-delay: 0.3s;
}

.dot8::before,
.dot8::after,
.dot8 i {
  animation-delay: 0.35s;
}

.dot9::before,
.dot9::after,
.dot9 i {
  animation-delay: 0.4s;
}

@keyframes helix {
  0% {
    width: 5px;
    height: 5px;
    bottom: -5px;
    z-index: 10;
  }
  25% {
    width: 2px;
    height: 2px;
  }
  50% {
    width: 5px;
    height: 5px;
    bottom: 100%;
    z-index: 20;
  }
  75% {
    width: 8px;
    height: 8px;
  }
  100% {
    width: 5px;
    height: 5px;
    bottom: -5px;
  }
}

@keyframes helix-reversed {
  0% {
    width: 5px;
    height: 5px;
    bottom: 100%;
    z-index: 20;
  }
  25% {
    width: 8px;
    height: 8px;
  }
  50% {
    width: 5px;
    height: 5px;
    bottom: -5px;
    z-index: 10;
  }
  75% {
    width: 2px;
    height: 2px;
  }
  100% {
    width: 5px;
    height: 5px;
    bottom: 100%;
  }
}

@keyframes helix-bar {
  0% {
    height: 15px;
  }
  25% {
    height: 8px;
  }
  50% {
    height: 15px;
  }
  75% {
    height: 8px;
  }
  100% {
    height: 15px;
  }
}

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2c67ab;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
